import React, { Fragment } from "react";
import { formatCurrency } from "../../../../../utils/Format";
import { OrderCostSummaryV2PdfProps } from "../index";
import LineItem from "../LineItem";
import {
  hfInformationCost,
  informationCost,
  informationCostDiscount,
  standardInformationCost
} from "../../../../../utils/Cost";
import OrderPolicy from "../../../../../policies/OrderPolicy";

const InformationCostVariant = (props: OrderCostSummaryV2PdfProps) => {
  const { user, cost, orderCategory, styles } = props;

  if (!OrderPolicy.canViewInformationCostBreakdown(user, orderCategory)) {
    return <LineItem styles={styles} label="Annual Information Cost" value={formatCurrency(informationCost(cost))} />
  }

  return (
    <Fragment>
      {
        <LineItem styles={styles} label="Annual Standard Information Cost"
                  value={formatCurrency(standardInformationCost(cost))} />
      }

      {
        <LineItem styles={styles} label="Annual High Frequency Information Cost"
                  value={formatCurrency(hfInformationCost(cost))} />
      }
    </Fragment>
  )
}

const InformationCost = (props: OrderCostSummaryV2PdfProps) => {
  const { cost, styles } = props;
  const { total_cost } = cost.data;

  if (!total_cost) {
    return null;
  }

  const isDiscounted = total_cost.information_cost !== total_cost.information_cost_after_discount;


  return (
    <Fragment>
      <InformationCostVariant {...props} />

      {
        isDiscounted &&
        <LineItem styles={styles} label="Applicable discount" value={formatCurrency(informationCostDiscount(cost))} />
      }
    </Fragment>
  )
}

export default InformationCost;
